import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  doc_no_start?: string;
  doc_no_end?: string;
  customer_start?: string;
  customer_end?: string;
  product_start?: string;
  product_end?: string;
  warehouse_start?: string;
  warehouse_end?: string;
  date_start?: string;
  date_end?: string;
  sort_mode: number; // 1=單號別, 2=日期別, 3=客戶別
}

export interface DetailItem {
  doc_no: string;
  related_doc_no: string;
  return_date: string;
  warehouse: string;
  currency: string;
  detail_seq: number;
  product_code: string;
  spec_code: string;
  unit_price: number;
  qty: number;
  unit: string;
  amount: number;
  rmb_amount: number;
  customer_code: string;
  product_name: string;
  product_spec: string;
}

export interface SubtotalItem {
  group_key: string;
  currency: string;
  unit: string;
  total_qty: number;
  total_amt: number;
  total_rmb: number;
}

export interface CurrencyTotal {
  currency: string;
  total_amt: number;
}

export interface UnitTotal {
  unit: string;
  total_qty: number;
  total_amt: number;
}

export interface GrandTotal {
  total_rmb: number;
}

export interface ReportData {
  details: DetailItem[];
  subtotals: SubtotalItem[];
  currency_totals: CurrencyTotal[];
  unit_totals: UnitTotal[];
  grand_total: GrandTotal;
  sort_mode: number;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const c330Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    const body: Record<string, unknown> = { sort_mode: filter.sort_mode || 1 };
    for (const [k, v] of Object.entries(filter)) {
      if (k === 'sort_mode') continue;
      if (v && typeof v === 'string' && v.trim() !== '') {
        body[k] = v.trim();
      }
    }
    const res = await apiClient.post('/api/c330/report', body);
    return res.data;
  },
};
